<template>
    <dash
        icon="fa fa-exclamation-circle"
        titulo="ENTREGAS E DESP. VIAGENS COM ERRO NO COMPROMETIMENTO"
        @click.native="
            $router.push({ name: 'Gestores_Paineis_Erros_Comprometimentos' })
        "
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
